import React, { useEffect, useContext } from 'react';
import { SettingsContext } from '../../context/SettingsProvider';

const ArchivedTable = () => {
  const { getArchiveData, archiveData, setArchiveData, updateArchiveData } =
    useContext(SettingsContext);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getArchiveData();
        if (response && response.data) {
          setArchiveData(response.data);
        } else {
          console.error('Response or response.data is undefined');
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Restore = (rowKey) => {
    updateArchiveData(rowKey);
  };

  return (
    <div>
      <div id="archived" className="mx-10 mb-3 mt-3 w-3/4 max-w-4xl overflow-hidden shadow sm:rounded-lg">
        <div className="flex justify-between bg-gray-400 p-2 dark:bg-stone-700">
          <h3 className="select-none font-semibold text-white">
            Archived Vendors
          </h3>
        </div>
        <div className="max-h-[80vh] overflow-y-scroll">
          <table className="min-w-full  ">
            <thead className="z-9 sticky top-0 bg-gray-500 dark:bg-stone-500">
              <tr>
                <th className="select-none px-2 py-3 text-left text-xs font-medium uppercase tracking-wider text-white">
                  Vendor
                </th>
                <th className="px-2 py-3 text-left text-xs font-medium uppercase tracking-wider text-white"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white dark:divide-gray-600 dark:bg-stone-900 dark:text-gray-300">
              {Array.isArray(archiveData) &&
                archiveData.map((archive, index) => (
                  <tr key={index}>
                    <td className="w-full whitespace-nowrap px-2 py-2">
                      <div className="select-none text-sm font-medium text-gray-900 dark:text-gray-300">
                        {archive.licensee}
                      </div>
                    </td>
                    <td className="whitespace-nowrap px-2 py-2 text-sm text-gray-500">
                      <button
                        className="inline-flex w-20 items-center justify-center rounded-md border border-transparent bg-blue-600 px-4 py-1 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 dark:bg-indigo-500 dark:hover:bg-indigo-600"
                        onClick={() => Restore(archive.rowKey)}
                      >
                        Restore
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ArchivedTable;
